export const portugues = {
    "Connecting...": "Conectando ...",
    "Finding a representative...": "Encontrando um representante ...",
    "Please wait...": "Por favor, espere...",
    "chat-notice": "Esta é uma solicitação de chamada de vídeo do portal MyPardini.",
    "required!": "obrigatório!",
    "Required": "Obrigatório",
    "Not an email": "Não é um email",
    "Start call": "Comece a ligar",
    "write a reply...": "escreva uma resposta...",
    "Register": "Minha informação",
    "first name": "primeiro nome",
    "last name": "último nome",
    "email": "o email",
    "subject": "sujeito",
    "type your name": "digite seu nome",
    "Agent": "Agente conectado",
    "Chatting with agent": "Conversando com agente",
    "Thank you for contacting us": "Obrigado por nos contatar",
    "Hi there!": "Olá, bem vindo ao MyPardini!",
    "How may we help you?": "Como podemos ajudá-lo?",
    "Media devices not available. Please check your permissions.": "Dispositivos de mídia não disponíveis. Por favor, verifique suas permissões.",
    "Checking devices...": "Verificando dispositivos ...",
    "Video call": "Video chamada",
    "Schedule Call": "Chamada de agendamento",
    "Schedule a video call": "Agende uma chamada de vídeo",
    "Time": "Tempo",
    "Confirm": "confirme",
    "Please enter the 6-digit code": "Por favor, insira o código de 6 dígitos",
    "Request new code": "Solicitar novo código",
    "Back": "Voltar",
    "Schedule": "Cronograma",
    "Mobile Phone number": "Número de celular",
    "AM": "SOU",
    "PM": "PM",
    "Today": "Hoje",
    "Tomorrow": "Amanhã",
    "Mon": "Seg",
    "Tue": "Ter",
    "Wed": "Qua",
    "Thu": "Qui",
    "Fri": "Sex",
    "Sat": "Sab",
    "Sun": "Dom",
    "January": "Janeiro",
    "February": "fevereiro",
    "March": "marchar",
    "April": "abril",
    "May": "Poderia",
    "June": "Junho",
    "July": "Julho",
    "August": "agosto",
    "September": "setembro",
    "October": "Outubro",
    "November": "novembro",
    "December": "dezembro",
    "Could not schedule the call. Something unexpected happened.": "Não foi possível agendar a chamada. Algo inesperado aconteceu.",
    "Could not request OTP": "Não foi possível solicitar otp",
    "Please add this call to your calendar.": "Por favor, adicione esta ligação ao seu calendário.",
    "Copy": "cópia de",
    "Start over": "Recomeçar",
    "Download .ics": "Download .ics.",
    "typing": "Digitando",
    "On hold": "Em espera",
    "Muted": "Silenciado",
    "chat-notice-voice": "Esta é uma solicitação de chamada de voz do widget Auvious. Abra Auviáveis ​​e inicie uma chamada de voz. O cliente vai participar depois de participar da chamada.",
    "Action disabled": "Ação desativada",
    "Call on hold": "Chamada em espera",
    "Please enable screen recording in your System Preferences": "Por favor, ative a gravação da tela em suas preferências do sistema",
    "Start chat": "Inicie o bate-papo",
    "Invalid OTP code.": "Código OTP inválido.",
    "Voice call": "Chamada de áudio.",
    "Chat": "Bate-papo",
    "Are you sure?": "Tem certeza?",
    "Cancel": "Cancelar",
    "Pick a date": "Escolha uma data",
    "Name": "Nome",
    "You will receive a one-time-password": "Você receberá uma senha única",
    "Yes": "sim",
    "Video call scheduled for": "Chamada de vídeo programada para",
    "Room Link": "Link do quarto",
    "Add to Google Calendar": "Adicionar ao Google Calendar",
    "Add to Outlook": "Adicionar ao Outlook.",
    "Mute": "Mudo",
    "Unmute": "Incomodar",
    "Share your screen": "Compartilhe sua tela",
    "Stop sharing": "Pare de compartilhar",
    "Not supported browser": "Não suportado navegador.",
    "Please try again later": "Por favor, tente novamente mais tarde",
    "No agent seems to be available at the moment.": "Nenhum agente parece estar disponível no momento.",
    "Customer's language is": "O idimoa do cliente é",
    "en": "inglês",
    "el": "grego",
    "de": "alemão",
    "es": "espanhol",
    "fi": "finlandês",
    "nl": "holandês",
    "pl": "polonês",
    "sv": "sueco",
    "tr": "turco",
    "zh": "chinês",
    "pt": "Portugues",
    "Start now": "Comece agora",
    "Please enter the 7-digit code provided by the agent.": "Por favor, insira o código de 7 dígitos fornecido pelo agente.",
    "Media devices not available": "Dispositivos de mídia não disponíveis",
    "Please check your permissions.": "Por favor, verifique se o seu dispositivo não é usado por outro aplicativo e que você concedeu permissões.",
    "PIN already used": "Pino já usado",
    "Please request for a new one.": "Por favor, solicite um novo.",
    "Invalid PIN": "PIN inválido",
    "Please check for typos or case-sensitive characters.": "Por favor, verifique os erros de digitação ou caracteres sensíveis a maiúsculas.",
    "Error": "OUPS!",
    "Agent seems to be having some connectivity issues.": "Por favor, verifique os erros de digitação ou caracteres sensíveis a maiúsculas.",
    "Agent re-connected.": "Agente re-conectado.",
    "Agent left. Closing session...": "Agente deixado. Sessão de fechamento ...",
    "Co-browse ended": "CO-Browse terminou",
    "Agent is requesting access to control your page.": "O agente está solicitando acesso para controlar sua página.",
    "Agent is requesting access to view your page.": "O agente está solicitando acesso para visualizar sua página.",
    "Agent is viewing your page": "O agente está visualizando sua página",
    "Agent is controlling your page": "O agente está controlando sua página",
    "Start a co-browse session": "Inicie uma sessão de browse",
    "Your browser page is no longer shared with the agent.": "Sua página do navegador não é mais compartilhada com o agente.",
    "Co-browse": "Co-browse",
    "Could not send attachment": "Não foi possível enviar anexo",
    "Initiating session...": "Iniciando a sessão ...",
    "Could not create a new interaction.": "Não pôde criar uma nova interação.",
    "There seems to be an issue with the connection.": "Parece haver um problema com a conexão.",
    "Connection lost": "Conexão perdida",
    "Connection restored": "Conexão restaurada",
    "Connected": "Conectado",
    "We hope to see you again soon.": "Esperamos voltar a vê-lo em breve.",
    "Transferring...": "Transferindo ...",
    "Agree to continue": "Concordar em continuar",
    "Invalid phone number": "Número de telefone inválido",
    "Consent not given": "Consentimento não dado",
    "agent": "Agente",
    "File size too big": "Tamanho do ficheiro demasiado grande",
    "The maximum allowed file size is": "O tamanho máximo de ficheiro permitido é",
    "File Download failed": "O descarregamento de ficheiros falhou",
    "Please try again": "Por favor tente novamente",
    "Agent is requesting a call": "O agente está a solicitar uma chamada",
    "chat-customer-rejected": "Pedido de chamada rejeitado pelo cliente. Enviar um novo link para o chat para pedir novamente.",
    "Open": "Aberto",
    "Closed": "Fechado",
    "Working hours": "Horário de trabalho",
    "Timezone": "Fuso horário",
    "All day": "Todo o dia",
    "Rest of the days": "O resto dos dias",
    "We are closed at this time. Please check the working hours.": "Neste momento, estamos fechados. Por favor, verifique as horas de trabalho.",
    "Testing reCAPTCHA": "Teste reCAPTCHA",
    "reCAPTCHA test failed": "teste reCAPTCHA falhou",
    "Closing...": "Encerramento...",
    "Could not resume co-browse session": "Não foi possível retomar a sessão de co-pilotar. Por favor, solicite um novo PIN.",
    "Could not find contact information such as phone or schedule date. Please fill in the form again": "Não foi possível encontrar informações de contacto tais como telefone ou data de marcação. Por favor, preencha o formulário de novo",
    "Verification code not found. Please request a new OTP": "Código de verificação não encontrado. Solicite por favor um novo OTP",
    "Please check your phone number and country code": "Por favor verifique o seu número de telefone e o código do país",
    "get-display-media-not-supported": "A partilha de ecrã não é suportada por este dispositivo",
    "Please sign in to access this service": "Por favor, inicie sessão para aceder a este serviço",
    "Chat service could not start": "O serviço de chat não pôde começar",
    "Please refresh your page": "Actualize por favor a sua página",
    "Call ended. Would you like to stop co-browsing as well?": "A chamada terminou. Gostaria de deixar de utilizar o co-browsing também?",
    "Session is being recorded": "A sessão está a ser gravada",
    "Session is no longer recorded": "A sessão já não é registada",
    "Required field": "Campo obrigatório",
    "Please type a name to continue.": "Por favor, escreva um nome para continuar.",
    "Microphone blocked": "Microfone bloqueado",
    "Camera & microphone blocked": "Câmara e microfone bloqueados",
    "Please allow this page to access your microphone.": "Permita que esta página aceda ao seu microfone.",
    "Please allow this page to access your camera & microphone.": "Permita que esta página aceda à sua câmara e microfone.",
    "Terminating conversation": "Terminar a conversa",
    "Not Supported browser": "Navegador não suportado",
    "Please update or use a more modern browser": "Actualize ou utilize um browser mais moderno",
    "Next": "Seguinte",
    "Selected Date": "Data selecionada",
    " We are closed at this date. Please check the working hours.": " Estamos encerrados nesta data. Por favor, verifique o horário de funcionamento.",
    "Pick a time slot": "Escolher uma faixa horária",
    "Please provide your contact details.": "Forneça os seus dados de contacto.",
    "Estimated wait time in queue": "Tempo de espera estimado na fila de espera",
    "Invalid code": "Código inválido",
    "Message us": "Enviar-nos uma mensagem",
    "Please choose a different time": "Escolha uma hora diferente",
    "Another appointment has already been scheduled for that time.": "Já foi marcada uma nova consulta para essa altura.",
    "Overlapping appointment": "Nomeação sobreposta",
    "The request was abruptly terminated": "O pedido foi encerrado abruptamente",
    "pcEnvironment is missing": "pcEnvironment está em falta",
    "pc-queue-id is required for the queue-estimate-wait-time": "pc-queue-id é necessário para o queue-estimate-wait-time",
    "dcTouchpointId is missing": "dcTouchpointId está em falta",
    "Customer email and/or subject are missing": "O e-mail e/ou o assunto do cliente estão em falta",
    "registrationType is not valid": "registrationType não é válido",
    "pcQueue is missing": "pcQueue está em falta",
    "pcOrganizationId is missing": "pcOrganizationId está em falta",
    "pcDeploymentId is missing": "pcDeploymentId está em falta",
    "one of data-url, comet-url must be defined": "um dos data-url, comet-url deve ser definido",
    "if using 'comet', 'comet-url' must be defined": "se estiver a utilizar \"comet\", deve ser definido \"comet-url",
    "if using 'comet', 'comet-channel' must be defined": "se utilizar \"comet\", deve ser definido \"comet-channel",
    "auviousEnvironment is missing": "auviousEnvironment está em falta",
    "grettingAction is not valid": "grettingAction não é válida",
    "applicationId is missing": "applicationId está em falta",
    "schedulePicker is not valid": "schedulePicker não é válido",
    "pcCallbackQueue is required for callback": "pcCallbackQueue é necessário para a chamada de retorno",
    "pcCallbackQueue or pcQueue is required for an appointment": "pcCallbackQueue ou pcQueue é necessário para uma marcação",
    "pcEnvironment is required for an appointment": "pcEnvironment é necessário para uma marcação",
    "pcDeploymentId is required for an appointment": "pcDeploymentId é necessário para uma marcação",
    "applicationId is required for an appointment": "applicationId é necessário para uma marcação",
    "scheduleMode is not valid": "scheduleMode não é válido",
    "not a valid locale": "não é uma localidade válida",
    "Please verify the pcEnvironment, queue name, organization id and deployment id. Reason: ": "Verifique o pcEnvironment, o nome da fila, o ID da organização e o ID da implantação. Motivo:",
    "Please verify the pcEnvironment, organization id and deployment id.": "Verifique o pcEnvironment, o ID da organização e o ID da implantação.",
    "Bad request. Please verify the application id, touchpoint id and other data.": "Pedido incorreto. Verifique o ID da aplicação, o ID do ponto de contacto e outros dados.",
    "Not authorized. Please check your talkdesk client id & secret in auvious settings and the customer email and subject.": "Não autorizado. Verifique o ID e o segredo do seu cliente talkdesk nas definições anteriores e o e-mail e assunto do cliente.",
    "Not found": "Não encontrado",
    "Customer's name is": "O nome do cliente é",
    "Co-browse conferenceId required. Authenticate first.": "É necessário o Co-browse conferenceId. Autenticar primeiro.",
    "Ready to join?": "Pronto para ingressar?",
    "Test speakers": "Testar auto falantes"
  }